export default __webpack_public_path__ + "static/media/small-is-powerful-earth-banner-mob.88729b56.jpg";